export default __webpack_public_path__ + "static/media/pg-14.2074f9f9.jpg";